import { render, staticRenderFns } from "./export-records.vue?vue&type=template&id=3244e9de&scoped=true"
import script from "./export-records.vue?vue&type=script&lang=js"
export * from "./export-records.vue?vue&type=script&lang=js"
import style0 from "./export-records.vue?vue&type=style&index=0&id=3244e9de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244e9de",
  null
  
)

export default component.exports